<template>
    <div>
        <AlertText msg-key="notifications.alerts.entrance" :zone="zone" />
    </div>
</template>

<script setup>
  import AlertText from './AlertText.vue'

  defineProps({
      zone: String,
  })
</script>
